import {     
    initCheckout,     
    logState, 
} from "./app.js";


// NOTE: the final bundled JS is not a module and most be included using plain old <script> tags - main.js serves as
// entry point for the application - attaching the exported init function to global context so that it can be run from <script> tags to init checkout
window.App = {
    initCheckout,
    logState
}